/* eslint-disable id-blacklist */
import * as React from 'react';
import * as api from './api/courseMatrixApi';
import { Modal } from './modal';
import { EventTimeResult, EventTime, Attendee, SendResponse } from '../../Model/core';
import { autobind } from './autobind';
import { className } from './className';
import { payload, mobile } from './main';

function getEventData() {
    if (mobile) {
        return payload.EventData;
    }

    const ed = payload.EventData.slice(0);
    let indices: number[] = [];

    for (let i = 0; i < ed.length; i++) {
        let current = ed[i];
        let next = ed[i + 1];

        let hasCat = current.Events.some(e => !!e.Category && e.Category.length > 0);

        if (next && hasCat) {
            indices.push(i + 1);
        }
    }

    for (let index of indices) {
        let next = { ...ed[index] };
        let ev = next.Events.slice(0).map(e => ({ ...e }));

        for (let e of ev) {
            e.Category = '';
        }

        next.Events = ev;
        ed[index] = next;
    }

    return ed;
}

interface MatrixProps {
}

interface MatrixState {
    attendees: AttendeeItem[];
    sendResponse?: SendResponse;
}

interface AttendeeItem extends Attendee {
    [key: string]: string;
    id: string;
}

interface AttendeeProps {
    attendee: AttendeeItem;
    extraAttendee: boolean;
    onChange: (key: keyof AttendeeItem, value: string) => void;
    onRemove: () => void;
}

class AttendeeForm extends React.Component<AttendeeProps> {

    @autobind
    handleChange(key: keyof AttendeeItem) {
        return (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            this.props.onChange(key, e.target.value);
        };
    }

    @autobind
    handleRemove(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();

        if (this.props.extraAttendee) {
            this.props.onRemove();
        }
    }

    render() {
        const { attendee, extraAttendee } = this.props;
        const { comment, email, company, name } = attendee;

        return (
            <div className={className('cm-matrix-attendee', { 'cm-matrix-extra-attendee': extraAttendee })}>
                {extraAttendee && <>
                    <h4 className='as-cm-matrix-item-title'>Extradeltagare:</h4>
                    <button className='cm-matrix-attendee-button cm-matrix-attendee-remove'
                        onClick={this.handleRemove}>Ta bort</button>
                </>}

                <div className='cm-matrix-attendee-row'>
                    <label>
                        Företag: *
                        <input type='text' value={company} onChange={this.handleChange('company')} required />
                    </label>
                </div>

                <div className='cm-matrix-attendee-row'>
                    <label>
                        Namn: *
                        <input type='text' value={name} onChange={this.handleChange('name')} required />
                    </label>
                </div>

                <div className='cm-matrix-attendee-row'>
                    <label>
                        Email: *
                        <input type='email' value={email} onChange={this.handleChange('email')} required />
                    </label>
                </div>

                <div className='cm-matrix-attendee-row'>
                    <label>
                        Kommentar:
                        <textarea value={comment} onChange={this.handleChange('comment')} />
                    </label>
                </div>
            </div>
        );
    }
}

function makeAttendee(): AttendeeItem {
    return {
        Name: '',
        Email: '',
        Comment: '',
        Company: '',
        id: Math.random().toString(16)
    };
}

interface SelectedItemsObject {
    [row: number]: string | null;
}

export class Matrix extends React.Component<MatrixProps, MatrixState> {

    private selectedItems: SelectedItemsObject = {};

    constructor(props: MatrixProps) {
        super(props);

        this.state = {
            attendees: [
                makeAttendee()
            ]
        };
    }

    @autobind
    handleAttendeChange(attende: AttendeeItem, index: number) {
        return (key: keyof AttendeeItem, value: string) => {
            const state = this.state;
            state.attendees[index][key] = value;
            this.setState(state);
        };
    }

    @autobind
    handleSubmitFormAttendee(e: React.MouseEvent<HTMLElement>) {
        e.preventDefault();
        this.sendForm();
    }

    async sendForm() {
        const selectedEventIds = Object.keys(this.selectedItems)
            .map(k => this.selectedItems[+k])
            .filter(ev => ev != null) as string[];

        if (!selectedEventIds.length) {
            alert('Välj något evenemang och försök igen.');
            return;
        }

        const sendResponse = await api.send({
            Attendees: this.state.attendees,
            SelectedEventIds: selectedEventIds
        });

        this.setState({ sendResponse });
    }

    @autobind
    addAttendee(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();

        const state = this.state;
        state.attendees.push(makeAttendee());
        this.setState(state);
    }

    @autobind
    handleSelectedItem(row: number) {
        return (eventId: string | null) => {
            this.selectedItems[row] = eventId;
        };
    }

    @autobind
    handleRemoveAttendee(attendee: AttendeeItem) {
        return () => {
            this.setState({ attendees: this.state.attendees.filter(at => at !== attendee) });
        };
    }

    @autobind
    handleModalClose() {
        window.location.reload();
    }

    render() {
        const { sendResponse } = this.state;
        const eventData = getEventData();

        if (payload.FormView) {
            return (
                <div className='cm-matrix-container'>
                    {eventData.map((ed, index) =>
                        <MatrixTimeRow key={ed.TimeString} row={ed} selectedItem={this.handleSelectedItem(index)} />)}

                    <div className='attendee-form-main-wrapper'>
                        <h4 className='as-cm-matrix-item-title'>Mina uppgifter:</h4>

                        <div className='cm-matrix-attendee-container'>
                            {this.state.attendees.map((attendee, index) =>
                                <AttendeeForm
                                    key={attendee.id}
                                    attendee={attendee}
                                    extraAttendee={index > 0}
                                    onRemove={this.handleRemoveAttendee(attendee)}
                                    onChange={this.handleAttendeChange(attendee, index)} />)}
                        </div>

                        {/* todo: avkommentera för extra deltagare */}
                        {/* <button
              className='attendee-form-button-add cm-matrix-attendee-button'
              onClick={this.addAttendee}>Lägg till deltagare</button> */}

                        {/* <input
              type='submit'
              className='attendee-form-button attendee-form-button-submit'
              onClick={this.handleSubmitFormAttendee}
              value='Bekräfta bokning' /> */}

                        <button
                            className='attendee-form-button attendee-form-button-submit'
                            onClick={this.handleSubmitFormAttendee}>Bekräfta bokning</button>

                        <Modal visible={!!sendResponse && sendResponse.success} className='cm-send-modal'>
                            <div className='cm-book-container'>
                                <div className='cm-send-response cm-success'>
                                    <div className='cm-send-response-row'>
                                        Tack för din anmälan!<br />En anmälningsbekräftelse skickas till din e-post.
                  </div>
                                    <div className='cm-send-response-row'>
                                        Vi ses på Redovisningsbyrådagen!
                  </div>
                                </div>

                                <div className='cm-book-close' onClick={this.handleModalClose} title='Stäng' tabIndex={-1}>
                                    <img src='/images/cancel-32.png' />
                                </div>
                            </div>
                        </Modal>

                        {!!sendResponse && !sendResponse.success && <>
                            <div className='cm-alert cm-alert-danger'>
                                {sendResponse.message}
                            </div>
                        </>}
                    </div>
                </div>
            );
        }

        return (
            <div className='cm-matrix-container'>
                {eventData.map(ed => <MatrixTimeRow key={ed.TimeString} row={ed} />)}
            </div>
        );
    }
}

interface MatrixTimeRowProps {
    row: EventTimeResult;
    selectedItem?: (eventId: string | null) => void;
}

interface MatrixTimeRowState {
    openedItem: EventTime | null;
    selectedItem: EventTime | null;
}

class MatrixTimeRow extends React.Component<MatrixTimeRowProps, MatrixTimeRowState> {

    constructor(props: MatrixTimeRowProps) {
        super(props);
        this.state = {
            openedItem: null,
            selectedItem: null
        };
    }

    @autobind
    handleToggleOpen(item: EventTime) {
        return () => {
            let it = this.state.openedItem === item ? null : item;
            this.setState({ openedItem: it });
        };
    }

    @autobind
    handleToggleSelected(item: EventTime) {
        return () => {
            let it = this.state.selectedItem === item ? null : item;
            this.setState({ selectedItem: it });

            if (this.props.selectedItem) {
                this.props.selectedItem(it === null ? null : it.EventId);
            }
        };
    }

    render() {
        const { row } = this.props;
        const { openedItem, selectedItem } = this.state;

        const someHaveCategory = row.Events.some(ev => !!ev.Category && ev.Category.length > 0);
        const allHaveBreak = row.Events.every(ev => ev.AllDayBreak);
        const style = {
            backgroundColor: openedItem && openedItem.Color && openedItem.Color.length ? openedItem.Color : undefined
        };

        return (
            <div className={className('cm-matrix-row', { 'cm-category': someHaveCategory, 'cm-day-break': allHaveBreak })}>
                <div className='cm-matrix-time'>{row.TimeString}</div>
                <div className='cm-matrix-item-container'>
                    <div className='cm-matrix-item-wrapper'>
                        {row.Events.map(it =>
                            <MatrixTimeItem
                                key={it.EventId}
                                item={it}
                                toggleOpen={this.handleToggleOpen(it)}
                                toggleSelected={this.handleToggleSelected(it)}
                                selected={!!selectedItem && selectedItem.EventId === it.EventId}
                                disabled={!!selectedItem && selectedItem.EventId !== it.EventId}
                                open={openedItem === it} />)}
                    </div>

                    {openedItem && <>
                        <div
                            className='cm-matrix-item-ingress'
                            style={style}
                            dangerouslySetInnerHTML={{ __html: openedItem.Ingress }}>
                        </div>

                        {/* {!payload.formView && <>
              <div className='cm-matrix-item-locations' style={style}>
                {openedItem.locationNames
                  .filter(n => n && n.length > 0)
                  .map(n => <div key={n} className='cm-matrix-item-location'>{n}</div>)}
              </div>
            </>} */}
                    </>}
                </div>
            </div>
        );
    }
}

interface MatrixTimeItemProps {
    item: EventTime;
    open: boolean;
    selected: boolean;
    disabled: boolean;
    toggleOpen: () => void;
    toggleSelected: () => void;
}

interface MatrixTimeItemState {
}

class MatrixTimeItem extends React.Component<MatrixTimeItemProps, MatrixTimeItemState> {

    private selectBox?: HTMLInputElement;

    constructor(props: MatrixTimeItemProps) {
        super(props);
    }

    @autobind
    handleToggle(e: React.MouseEvent<HTMLDivElement>) {
        if (this.selectBox && e.target === this.selectBox) {
            return;
        }

        this.props.toggleOpen();
    }

    @autobind
    handleChecked(e: React.ChangeEvent<HTMLInputElement>) {
        e.stopPropagation();
        this.props.toggleSelected();
    }

    render() {
        const { item, open, selected, disabled } = this.props;

        const style = { backgroundColor: item.Color && item.Color.length ? item.Color : undefined };
        const styleCategory = {
            color: item.CourseMatrixColorTitle && (item.CourseMatrixColorTitle && window.innerWidth <= 768)
                ? item.CourseMatrixColorTitle
                : undefined
        };

        if (item.AllDayBreak) {
            return (
                <div className='cm-matrix-item cm-day-break'>
                    <div className='cm-matrix-item-header' style={style}>
                        <div className='cm-matrix-item-title'>{item.Title}</div>
                    </div>
                </div>
            );
        }

        const disabledBooking = !item.AllowQueue && item.IsMaxedOut;

        return (
            <div className={className('cm-matrix-item', { 'cm-open': open, 'cm-disabled': disabled || disabledBooking })} style={style}>
                {!!item.Category && item.Category.length > 0 && <>
                    <div className='cm-matrix-item-category' style={styleCategory}>
                        <div className='cm-matrix-item-category-text'>{item.Category}</div>
                    </div>
                </>}

                <div className='cm-matrix-item-header' onClick={this.handleToggle} style={style}>
                    {payload.FormView && <>
                        <input
                            className='cm-matrix-item-select'
                            ref={elm => this.selectBox = elm as HTMLInputElement}
                            type='checkbox'
                            checked={selected}
                            disabled={disabledBooking}
                            onChange={this.handleChecked} />
                    </>}

                    <div className='cm-matrix-item-header-title'>
                        {!payload.FormView && item.LocationNames && item.LocationNames.length === 1
                            && item.LocationNames[0].length > 0 &&
                            <>
                                <div className='cm-matrix-item-location'>OBS! Endast i {item.LocationNames[0]}</div>
                            </>}

                        {payload.FormView && item.IsMaxedOut && <>
                            <div className='cm-matrix-item-status'>
                                {item.AllowQueue ? 'Endast köplats tillgänglig' : 'Fullbokat'}
                            </div>
                        </>}

                        <div className='cm-matrix-item-title'>{item.Title}</div>
                        <div className='cm-matrix-item-desc'>{item.Desc}</div>
                    </div>

                    <div className='cm-matrix-item-header-toggle'>
                        <img src={open
                            ? '/images/cancel-32.png'
                            : '/images/next-page-32.png'} />
                    </div>
                </div>

                {open && <>
                    <div className='cm-matrix-item-nestedingress'
                        dangerouslySetInnerHTML={{ __html: item.Ingress }}
                        style={style} >
                    </div>
                </>}
            </div>
        );
    }
}